import React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";
import { Container } from "reactstrap";
import { XCircleLoader } from "components";
import { useTranslate } from "hooks";
import { useProductsOverviewStore } from "stores/productsOverviewStore";
import type { NiceModalHandler } from "@ebay/nice-modal-react";
import type { FetchError } from "utils";
import s from "./ProductsOverview.module.scss";
import { ProductsOverviewHeader } from "./ProductsOverviewHeader";
import { ProductsOverviewBody } from "./ProductsOverviewBody";

export type ProductsOverviewProps = {
  error?: FetchError | null;
  title?: React.ReactNode;
  isModalActive?: boolean;
  id?: string;
  dummy?: string;
  wizardType?: string;
  modal?: NiceModalHandler<Record<string, unknown>>;
  handleBackAction?: () => void;
  type?: string;
  groupPosition?: number;
  infoText?: string;
};

export const ProductsOverview = Scrivito.connect(
  ({ error, title, isModalActive, ...rest }: ProductsOverviewProps) => {
    const translate = useTranslate();
    const isImageFetching = useProductsOverviewStore(
      (state) => state.isImageFetching,
    );

    return (
      <>
        {isImageFetching ? (
          <XCircleLoader classNames="position-absolute bg-gray-100 d-flex h-100 w-100 overflow-hidden z-1" />
        ) : (
          <Container
            className={cx("pb-8 w-100", {
              [s.productsWrapper]: !isModalActive,
            })}
          >
            <ProductsOverviewHeader
              {...{
                title:
                  title || translate("PRODUCTS_OVERVIEW_PRODUCTS_LIST_TITLE"),
                isModalActive,
              }}
              {...rest}
            />
            <ProductsOverviewBody
              {...{
                error,
                isModalActive,
              }}
              {...rest}
            />
          </Container>
        )}
      </>
    );
  },
);
